// Fixed Quote Submission - Handles large carts and property errors
document.addEventListener('DOMContentLoaded', function() {
  const quoteButton = document.getElementById('quote-request-btn');
  if (!quoteButton) return;
  
  // Remove any existing handlers
  const newButton = quoteButton.cloneNode(true);
  quoteButton.parentNode.replaceChild(newButton, quoteButton);
  
  newButton.addEventListener('click', async function(e) {
    e.preventDefault();
    
    const button = this;
    const originalText = button.textContent;
    
    try {
      // Validate customer is logged in
      if (!window.customerEmail) {
        throw new Error('Please log in to submit a quote request');
      }
      
      button.disabled = true;
      button.textContent = 'Preparing quote...';
      
      // Get fresh cart data
      const cartResponse = await fetch('/cart.js?t=' + Date.now());
      if (!cartResponse.ok) {
        throw new Error('Failed to load cart');
      }
      
      const cart = await cartResponse.json();
      
      // Validate cart has items
      if (!cart.items || cart.items.length === 0) {
        throw new Error('Your cart is empty. Please add items before requesting a quote.');
      }
      
      button.textContent = `Processing ${cart.items.length} items...`;
      
      console.log('Quote submission:', {
        customer: window.customerEmail,
        items: cart.items.length,
        total: cart.total_price
      });
      
      // Create quote summary for local download
      let summary = `QUOTE REQUEST - NICHE ISTANBUL\n`;
      summary += `================================\n\n`;
      summary += `Customer: ${window.customerEmail}\n`;
      summary += `Date: ${new Date().toLocaleString()}\n`;
      summary += `Total Items: ${cart.items.length}\n`;
      summary += `Total Amount: ${(cart.total_price/100).toFixed(2)} gr\n\n`;
      summary += `ITEMS:\n`;
      summary += `================================\n\n`;
      
      // Process items in chunks to avoid memory issues
      cart.items.forEach((item, index) => {
        try {
          summary += `${index + 1}. ${item.title || 'Unknown Product'}\n`;
          
          if (item.variant_title) {
            summary += `   Variant: ${item.variant_title}\n`;
          }
          
          summary += `   Quantity: ${item.quantity || 1}\n`;
          summary += `   Price: ${(item.price/100).toFixed(2)} gr\n`;
          summary += `   Subtotal: ${(item.line_price/100).toFixed(2)} gr\n`;
          
          // Safely handle properties (could be array, object, or undefined)
          if (item.properties) {
            try {
              // If properties is an array
              if (Array.isArray(item.properties)) {
                const noteProperty = item.properties.find(p => p && p.name === 'Line item note');
                if (noteProperty && noteProperty.value) {
                  summary += `   Note: ${noteProperty.value}\n`;
                }
              } 
              // If properties is an object
              else if (typeof item.properties === 'object') {
                if (item.properties['Line item note']) {
                  summary += `   Note: ${item.properties['Line item note']}\n`;
                }
                // Also check for other property formats
                Object.keys(item.properties).forEach(key => {
                  if (key !== 'Line item note' && item.properties[key]) {
                    summary += `   ${key}: ${item.properties[key]}\n`;
                  }
                });
              }
            } catch (propError) {
              console.warn('Error processing properties for item', index, propError);
            }
          }
          
          summary += '\n';
        } catch (itemError) {
          console.error('Error processing item', index, itemError);
          summary += `   [Error processing this item]\n\n`;
        }
      });
      
      summary += `================================\n`;
      summary += `TOTAL: ${(cart.total_price/100).toFixed(2)} gr\n`;
      
      if (cart.note) {
        summary += `\nORDER NOTE:\n${cart.note}\n`;
      }
      
      // Try to send to server first
      try {
        button.textContent = 'Sending to server...';
        
        // Prepare customer data
        const customerData = {
          email: window.customerEmail,
          name: window.customerName || window.customerEmail.split('@')[0],
          // Add other customer data if available
        };
        
        // Send to YOUR Render service, not Shopify
        const response = await fetch('https://nicheistanbul-shopify.onrender.com/quote', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            cart: cart,
            customer: customerData
          })
        });
        
        if (response.ok) {
          const result = await response.json();

          // CRITICAL: Cancel any pending cart save first, then disable sync.
          // This prevents a slow debouncedSaveCart from re-saving old items
          // AFTER the persistent cart has been cleared (race condition fix).
          if (window.PersistentCart && window.PersistentCart.cancelPendingSave) {
            window.PersistentCart.cancelPendingSave();
          }
          window.quoteSubmitted = true;
          window.cartSyncDisabled = true;

          // Get customer ID for clearing persistent cart
          const customerId = window.customerId || window.customerData?.id;

          // FIRST: Clear persistent cart on backend (prevents 409 errors)
          if (customerId) {
            try {
              await fetch(`https://my-cart-endpoints.onrender.com/apps/clear_cart?customer_id=${customerId}&shop=vp3tj7-yb.myshopify.com`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ reason: 'quote_submitted' })
              });
              console.log('Persistent cart cleared');
            } catch (err) {
              console.warn('Could not clear persistent cart:', err);
            }
          }

          // THEN: Clear Shopify cart
          try {
            await fetch('/cart/clear.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' }
            });
            console.log('Shopify cart cleared');
          } catch (err) {
            console.warn('Could not clear Shopify cart:', err);
          }

          // FINALLY: Redirect to success page
          let redirectUrl = '/pages/order-request-sent';
          if (result.order) {
            redirectUrl += `?order=${result.order}`;
          }
          window.location.href = redirectUrl;

          return; // Exit early on success
        } else {
          // Server rejected - fall back to download
          const errorText = await response.text();
          console.error('Server error:', response.status, errorText);
          button.textContent = 'Server error - downloading locally...';
        }
      } catch (serverError) {
        console.error('Failed to send to server:', serverError);
        button.textContent = 'Offline - downloading locally...';
      }
      
      // Fallback: Download file locally
      const blob = new Blob([summary], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `quote_${window.customerEmail}_${Date.now()}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      
      button.textContent = 'Quote downloaded locally!';
      button.classList.add('button--warning');
      
      // Reset button after 3 seconds
      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('button--success', 'button--warning');
        button.disabled = false;
      }, 3000);
      
    } catch (error) {
      console.error('Quote submission error:', error);
      alert('Error: ' + error.message);
      button.textContent = originalText;
      button.disabled = false;
    }
  });
});